import { render, staticRenderFns } from "./monitoring.coreos.com.route.vue?vue&type=template&id=4908d104&"
import script from "./monitoring.coreos.com.route.vue?vue&type=script&lang=js&"
export * from "./monitoring.coreos.com.route.vue?vue&type=script&lang=js&"
import style0 from "./monitoring.coreos.com.route.vue?vue&type=style&index=0&id=4908d104&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports